export const genera = [
    {
        cardName: "Jio Saavn, App",
        img: "Mask Group 1",
        name: "Advertising in Jio Saavn, App",
        heading: "About Advertising in Jio Saavn, App",
        monthyUsers : "25.2M",
        discription: "Jio Saavn is the largest digital music streaming service for South Asians globally. It is a revolutionary streaming music service reinventing how people listen and share music, in India and around the world. Jio Saavn has a wide variety of music and podcasts available on its platform along with originals.Get all media options &amp; best rates for Saavn App through The Media Ant.",
        topChoices: 
        [
            {
                name: "Audio",
                imgBrand: "Mask Group 1",
                monthyUsers : "25.2M",
                heading: "Audio on Jio Saavn, App",
                img: ["topimg1.jpeg","bottom2.jpeg", "bottom1.jpeg"],
                description: "An audio ad of not more than 30 sec is supported by a clickable banner ad .",
                detail: ["Reach","Image","3","At the end of campagin only","1 Days"],
                price: "₹ 0.1 / Per Impression",
                productDescription: [["#Maximum audio length 30 sec # Advertiser Name Maximum 45 characters #CTA Text also required # URLs should direct to https destinations only."],["0.10%"]]
            },
            {
                name: "Banner",
                imgBrand: "Mask Group 1",
                monthyUsers : "25.2M",
                heading: "Banner on Jio Saavn, App",
                img: ["topimg1.jpeg","bottom2.jpeg", "bottom1.jpeg"],
                description: "Rectangular Image ad (Banner) which will appear on all the pages.",
                detail: ["Reach","Image","3","At the end of campagin only","1 Days"],
                price: "₹ 0.1 / Per Impression",
                productDescription: [["#Max File Size 150 kb #Background must be a solid color/image and not transparent # ClickTag and Replay button will be embed on creative"],["0.10%"]]
            },
            {
                name: "Video",
                imgBrand: "Mask Group 1",
                monthyUsers : "25.2M",
                heading: "Video on Jio Saavn, App",
                img: ["topimg1.jpeg","bottom2.jpeg", "bottom1.jpeg"],
                description: "It is a video ad on all the pages which is automatically played to the user as soon as the page is loaded.",
                detail: ["Impact","Vidio","3","At the end of campagin only","1 Days"],
                price: "₹ 0.45 / Per Impression",
                productDescription: [[" No black bars (no letter-boxing, pillar-boxing, or window-boxing).Video must be submitted without leaders (no slates, countdowns, etc.).All files must include sound - no silent videos will be accepted # For Comapnion Banner creative may include call-to-action. CTA Text is required"],["0.10%"]]
            },
            {
                name: "Masthead Banner",
                imgBrand: "Mask Group 1",
                monthyUsers : "25.2M",
                heading: "Masthead Banner on Jio Saavn, App",
                img: ["topimg1.jpeg","bottom2.jpeg", "bottom1.jpeg"],
                description: "It is a large banner placed on the top of the screen and is the first piece of content that the user sees.",
                detail: ["Impact","Image","3","At the end of campagin only","1 Days"],
                price: "₹ 6,50,000 /",
                productDescription: [[" No black bars (no letter-boxing, pillar-boxing, or window-boxing).Video must be submitted without leaders (no slates, countdowns, etc.).All files must include sound - no silent videos will be accepted # For Comapnion Banner creative may include call-to-action. CTA Text is required"],["0.10%"]]
            },
        ]
    },
    {
        cardName: "Facebook, App",
        img: "Mask Group 2",
        name: "Advertising in Facebook, Website",
        heading: "About Advertising in Facebook, Website",
        monthyUsers : "340M",
        discription: "Facebook is a popular social networking website used for connecting with Family and Friends. Facebook has an enormous reach of 2.7 billion users globally. In the subcontinent of India, Facebook has a reach of 250 million. Further, Facebook is available in various regional languages in India and is hence one of the highest penetrated social media platforms in the county.",
        topChoices: 
        [
            {
                name: "Banner",
                imgBrand: "Mask Group 2",
                monthyUsers : "340M",
                heading: "Banner on Facebook, Website",
                img: ["topimg1.jpeg","bottom2.jpeg", "bottom1.jpeg"],
                description: "Rectangular Image ad (Banner) which will appear on all the pages.",
                detail: ["React","Image","3","At the end of campagin only","1 Days"],
                price: "₹ 0.05 / Per Unit",
                productDescription: [[" 1080x1080, 1080x1920"],["0.10%"]]
            },
            {
                name: "Video",
                imgBrand: "Mask Group 2",
                monthyUsers : "340M",
                heading: "Video on Facebook, Website",
                img: ["topimg1.jpeg","bottom2.jpeg", "bottom1.jpeg"],
                description: "It is a video ad on all the pages which is automatically played to the user as soon as the page is loaded.",
                detail: ["Impact","Video","3","At the end of campagin only","1 Days"],
                price: "₹ 0.06 / Per Impression",
                productDescription: [[" 1080x1080, 1080x1920"],["0.10%"]]
            },
            {
                name: "Carousel",
                imgBrand: "Mask Group 2",
                monthyUsers : "340M",
                heading: "Carousel on Facebook, Website",
                img: ["topimg1.jpeg","bottom2.jpeg", "bottom1.jpeg"],
                description: "Carousal ads have a number of rectangular images lined next to each other left to right. These can be scrolled on the screen in either direction.",
                detail: ["Impact","Image","3","At the end of campagin only","1 Days"],
                price: "₹ 0.05 / Per Unit",
                productDescription: [[" 1080x1080, 1080x1920"],["0.10%"]]
            },
            {
                name: "Catalogue Sale",
                imgBrand: "Mask Group 2",
                monthyUsers : "340M",
                heading: "Catalogue Sale on Facebook, Website",
                img: ["topimg1.jpeg","bottom2.jpeg", "bottom1.jpeg"],
                description: "A Sales campaign streamline the process for you, with a combination of properties such as Display, Video, SMS and e-mail for promotion.",
                detail: ["Impact","Video","3","At the end of campagin only","1 Days"],
                price: "₹ 10 / Per Click",
                productDescription: [[" 1080x1080, 1080x1920"],["0.10%"]]
            },
        ]
    },
    {
        cardName: "Youtube, App",
        img: "Mask Group 3",
        name: "Advertising in YouTube, Website",
        heading: "About Advertising in YouTube, Website",
        monthyUsers : "2B",
        discription: "Youtube is one of the top sites (3rd in rank after Google.com and Google.co.in) according to Alexa Top sites in India. With 265 million as monthly user base, it has already reached 80% of the internet population in India. Hence, Youtube advertising in India is a very good opportunity for brands to reach their target audience.Get the best rates for advertising on Youtube with The Media",
        topChoices: 
        [
            {
                name: "Video",
                imgBrand: "Mask Group 3",
                monthyUsers : "2B",
                heading: "Video on YouTube, Website",
                img: ["topimg1.jpeg","bottom2.jpeg", "bottom1.jpeg"],
                description: "It is a video ad that will be played on youtube and associated youtube partners.",
                detail: ["Impact","Video","3","At the end of campagin only","1 Days"],
                price: "₹ 0.03 / Per View",
                productDescription: [[" 1080x1080, 1080x1920"],["0.10%"]]
            },
            {
                name: "Banner",
                imgBrand: "Mask Group 3",
                monthyUsers : "2B",
                heading: "Banner on YouTube, Website",
                img: ["topimg1.jpeg","bottom2.jpeg", "bottom1.jpeg"],
                description: "These are high impact banner packages with prime placements.",
                detail: ["Impact","Video","3","At the end of campagin only","1 Days"],
                price: "₹ 5 / Per Click",
                productDescription: [[" 1080x1080, 1080x1920"],["0.10%"]]
            },
            {
                name: "Masthead",
                imgBrand: "Mask Group 3",
                monthyUsers : "2B",
                heading: "Masthead on YouTube, Website",
                img: ["topimg1.jpeg","bottom2.jpeg", "bottom1.jpeg"],
                description: "It is a banner ad embedded with video on the top of webpage.",
                detail: ["Impact","Video","3","At the end of campagin only","1 Days"],
                price: "₹ 25,00,000 / Per Day",
                productDescription: [[" 1080x1080, 1080x1920"],["0.10%"]]
            },
            {
                name: "Connected TV",
                imgBrand: "Mask Group 3",
                monthyUsers : "2B",
                heading: "Connected TV on YouTube, Website",
                img: ["topimg1.jpeg","bottom2.jpeg", "bottom1.jpeg"],
                description: "Connected TV advertising, or CTV advertising, allows brands to reach their audience on smart TVs and OTT devices.",
                detail: ["Impact","Video","3","At the end of campagin only","1 Days"],
                price: "₹ 25,00,000 / Per Day",
                productDescription: [[" 1080x1080, 1080x1920"],["0.10%"]]
            },
        ]
    },
    {
        cardName: "Instagram, App",
        img: "instagram",
        name: "Advertising in Instagram, App",
        heading: "About Advertising in Instagram, App",
        monthyUsers : "2B",
        discription: "Instagram is world’s largest social networking platform. When you Advertise in Instagram, you can reach out to the precise target group. Advertising platform of Instagram provides targeting like gender, location, interest, education level and age. It is one of the most targeted forms of social media and digital advertising. The Media Ant is a specialist agency for Instagram advertising and",
        topChoices: 
        [
            {
                name: "Banner",
                imgBrand: "instagram",
                monthyUsers : "2B",
                heading: "Banner on Instagram, App",
                img: ["topimg1.jpeg","bottom2.jpeg", "bottom1.jpeg"],
                description: "It is a rectangular image ad (Banner) with some text on the post feed (Facebook or Instagram ). The ad convey message about business nature of any brand.",
                detail: ["Reach","Image","1","At the end of campagin only","1 Days"],
                price: "₹ 0.05 / Per Unit",
                productDescription: [["1200 x 628 or 1080 x 1080files are 30MB maxThe caption maximum length is 2,200 characters, but 125 is recommendedAspect ration - 1.9:1 or 1:1", "Vertical Image Ads - 1080 x 1350Aspect Ratio - 4:5"],["0.8%"]]
            },
            {
                name: "Video",
                imgBrand: "instagram",
                monthyUsers : "2B",
                heading: "Video on Instagram, App",
                img: ["topimg1.jpeg","bottom2.jpeg", "bottom1.jpeg"],
                description: "It is a video ad on all the pages which is automatically played to the user as soon as the page is loaded",
                detail: ["Impact","Video","1","At the end of campagin only","1 Days"],
                price: "₹ 0.08 / Per Impression",
                productDescription: [["File formats include MP4 and MOVMax File Size - 4GBVideo Length - 120 secondsFrame Rate - 30 FPSLandscape - 600 x 315 pixelsSquare -600 x 600 pixelsVertical - 600 x 750 pixels"],["0.10%"]]
            },
            {
                name: "Carousel",
                imgBrand: "instagram",
                monthyUsers : "2B",
                heading: "Carousel on Instagram, App",
                img: ["topimg1.jpeg","bottom2.jpeg", "bottom1.jpeg"],
                description: "Carousal ads have a number of rectangular images lined next to each other left to right. These can be scrolled on the screen in either direction.",
                detail: ["Impact","Image","1","At the end of campagin only","1 Days"],
                price: "₹ 5 / Per Click",
                productDescription: [["1080 x 1080 pixelsAspect ratio: 1:1All formats should be either JPG or PNGMax image size is 30MB per image/card2-10 images/cards per ad"], ["0.8%"]]
            },
            {
                name: "Instagram Reels",
                imgBrand: "instagram",
                monthyUsers : "2B",
                heading: "Instagram Reels on Instagram, App",
                img: ["topimg1.jpeg","bottom2.jpeg", "bottom1.jpeg"],
                description: "Instagram Reels is a content format that allows you to create and share short engaging videos.Rack Rate",
                detail: ["Impact","Video","1","At the end of campagin only","1 Days"],
                price: "₹ 0.08 / Per Impression",
            },
        ]
    },
    {
        cardName: "Careem, App",
        img: "Mask Group 5",
        name: "Advertising in Careem, App",
        heading: "About Advertising in Careem, App",
        monthyUsers : "100k",
        discription: "Careem is a popular social networking app used for connecting with Family and Friends. Facebook has an enormous reach of 2.7 billion users globally. In the subcontinent of India, Facebook has a reach of 250 million. Further, Facebook is available in various regional languages in India and is hence one of the highest penetrated social media platforms in the county.",
        topChoices: 
        [
            {
                name: "Banner",
                imgBrand: "Mask Group 5",
                monthyUsers : "2B",
                heading: "Banner on Instagram, App",
                img: ["topimg1.jpeg","bottom2.jpeg", "bottom1.jpeg"],
                description: "It is a rectangular image ad (Banner) with some text on the post feed (Facebook or Instagram ). The ad convey message about business nature of any brand.",
                detail: ["Reach","Image","1","At the end of campagin only","1 Days"],
                price: "₹ 0.05 / Per Unit",
                productDescription: [["1200 x 628 or 1080 x 1080files are 30MB maxThe caption maximum length is 2,200 characters, but 125 is recommendedAspect ration - 1.9:1 or 1:1", "Vertical Image Ads - 1080 x 1350Aspect Ratio - 4:5"],["0.8%"]]
            },
            {
                name: "Video",
                imgBrand: "Mask Group 5",
                monthyUsers : "2B",
                heading: "Video on Instagram, App",
                img: ["topimg1.jpeg","bottom2.jpeg", "bottom1.jpeg"],
                description: "It is a video ad on all the pages which is automatically played to the user as soon as the page is loaded",
                detail: ["Impact","Video","1","At the end of campagin only","1 Days"],
                price: "₹ 0.08 / Per Impression",
                productDescription: [["File formats include MP4 and MOVMax File Size - 4GBVideo Length - 120 secondsFrame Rate - 30 FPSLandscape - 600 x 315 pixelsSquare -600 x 600 pixelsVertical - 600 x 750 pixels"],["0.10%"]]
            },
            {
                name: "Carousel",
                imgBrand: "Mask Group 5",
                monthyUsers : "2B",
                heading: "Carousel on Instagram, App",
                img: ["topimg1.jpeg","bottom2.jpeg", "bottom1.jpeg"],
                description: "Carousal ads have a number of rectangular images lined next to each other left to right. These can be scrolled on the screen in either direction.",
                detail: ["Impact","Image","1","At the end of campagin only","1 Days"],
                price: "₹ 5 / Per Click",
                productDescription: [["1080 x 1080 pixelsAspect ratio: 1:1All formats should be either JPG or PNGMax image size is 30MB per image/card2-10 images/cards per ad"], ["0.8%"]]
            },
            {
                name: "Instagram Reels",
                imgBrand: "Mask Group 5",
                monthyUsers : "2B",
                heading: "Instagram Reels on Instagram, App",
                img: ["topimg1.jpeg","bottom2.jpeg", "bottom1.jpeg"],
                description: "Instagram Reels is a content format that allows you to create and share short engaging videos.Rack Rate",
                detail: ["Impact","Video","1","At the end of campagin only","1 Days"],
                price: "₹ 0.08 / Per Impression",
            },
        ]
    },
    {
        cardName: "Uber, App",
        img: "Mask Group 6",
        name: "Advertising in Uber, App",
        heading: "About Advertising in Uber, App",
        monthyUsers : "200k",
        discription: "Uber is one of the top sites (3rd in rank after Google.com and Google.co.in) according to Alexa Top sites in India. With 265 million as monthly user base, it has already reached 80% of the internet population in India. Hence, Youtube advertising in India is a very good opportunity for brands to reach their target audience.Get the best rates for advertising on Youtube with The Media",
        topChoices: 
        [
            {
                name: "Banner",
                imgBrand: "Mask Group 6",
                monthyUsers : "2B",
                heading: "Banner on Instagram, App",
                img: ["topimg1.jpeg","bottom2.jpeg", "bottom1.jpeg"],
                description: "It is a rectangular image ad (Banner) with some text on the post feed (Facebook or Instagram ). The ad convey message about business nature of any brand.",
                detail: ["Reach","Image","1","At the end of campagin only","1 Days"],
                price: "₹ 0.05 / Per Unit",
                productDescription: [["1200 x 628 or 1080 x 1080files are 30MB maxThe caption maximum length is 2,200 characters, but 125 is recommendedAspect ration - 1.9:1 or 1:1", "Vertical Image Ads - 1080 x 1350Aspect Ratio - 4:5"],["0.8%"]]
            },
            {
                name: "Video",
                imgBrand: "Mask Group 6",
                monthyUsers : "2B",
                heading: "Video on Instagram, App",
                img: ["topimg1.jpeg","bottom2.jpeg", "bottom1.jpeg"],
                description: "It is a video ad on all the pages which is automatically played to the user as soon as the page is loaded",
                detail: ["Impact","Video","1","At the end of campagin only","1 Days"],
                price: "₹ 0.08 / Per Impression",
                productDescription: [["File formats include MP4 and MOVMax File Size - 4GBVideo Length - 120 secondsFrame Rate - 30 FPSLandscape - 600 x 315 pixelsSquare -600 x 600 pixelsVertical - 600 x 750 pixels"],["0.10%"]]
            },
            {
                name: "Carousel",
                imgBrand: "Mask Group 6",
                monthyUsers : "2B",
                heading: "Carousel on Instagram, App",
                img: ["topimg1.jpeg","bottom2.jpeg", "bottom1.jpeg"],
                description: "Carousal ads have a number of rectangular images lined next to each other left to right. These can be scrolled on the screen in either direction.",
                detail: ["Impact","Image","1","At the end of campagin only","1 Days"],
                price: "₹ 5 / Per Click",
                productDescription: [["1080 x 1080 pixelsAspect ratio: 1:1All formats should be either JPG or PNGMax image size is 30MB per image/card2-10 images/cards per ad"], ["0.8%"]]
            },
            {
                name: "Instagram Reels",
                imgBrand: "Mask Group 6",
                monthyUsers : "2B",
                heading: "Instagram Reels on Instagram, App",
                img: ["topimg1.jpeg","bottom2.jpeg", "bottom1.jpeg"],
                description: "Instagram Reels is a content format that allows you to create and share short engaging videos.Rack Rate",
                detail: ["Impact","Video","1","At the end of campagin only","1 Days"],
                price: "₹ 0.08 / Per Impression",
            },
        ]
    }
]